import { Monaco } from "@monaco-editor/react";

import { Highlight } from "@pages/editor/types";

export const makeHighlightDec = (highlighted: readonly Highlight[]) =>
  highlighted.map((hl) => ({
    range: hl.range,
    options: {
      inlineClassName: `highlight ${hl.type.toLowerCase()}`,
      zIndex: 1,
    },
  }));

export const makeHighlightLines = (
  highlighted: readonly Highlight[],
  monacoInstance: Monaco
) =>
  highlighted.map((hl) => ({
    range: new monacoInstance.Range(hl.startLine, 0, hl.endLine, Infinity),
    options: {
      isWholeLine: true,
      className: `highlight backdrop ${hl.type.toLowerCase()}`,
    },
  }));
